import {
  UPDATE_FOLDER_BREADCRUMB,
  UPDATE_FOLDER_FILTERS,
  UPDATE_FOLDER_SEARCH,
  TRIGGER_FETCH,
} from "./constants";

export const updateFolderBreadcrumb = (payload) => ({
  type: UPDATE_FOLDER_BREADCRUMB,
  payload,
});

export const updateFolderFilters = (payload) => ({
  type: UPDATE_FOLDER_FILTERS,
  payload,
});

export const updateFolderSearch = (payload) => ({
  type: UPDATE_FOLDER_SEARCH,
  payload,
});

export const triggerFetch = (payload) => ({
  type: TRIGGER_FETCH,
  payload,
});
